// Centralized data-testid registry (kebab-case role-based)
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  sidebarBrand: "sidebar-brand",
  dashboard: "nav-dashboard",
  signals: "nav-signals",
  rejected: "nav-rejected",
  paper: "nav-paper",
  logs: "nav-logs",
  backtest: "nav-backtest",
  settings: "nav-settings",
  runScanBtn: "topbar-run-scan-btn",
  schedulerPill: "topbar-scheduler-pill",
  healthPill: "topbar-health-pill",
};

export const DASH = {
  shell: "dashboard-shell",
  kpiActive: "kpi-active-signals",
  kpi24h: "kpi-signals-24h",
  kpi7d: "kpi-signals-7d",
  kpiRejected: "kpi-rejected-24h",
  kpiInterval: "kpi-scan-interval",
  gradeChart: "dashboard-grade-chart",
  regimeChart: "dashboard-regime-chart",
  topPairs: "dashboard-top-pairs",
  recentSignals: "dashboard-recent-signals",
  lastScanCard: "dashboard-last-scan",
  lifecycleStats: "dashboard-lifecycle-stats",
};

export const SIGNALS = {
  table: "signals-table",
  row: (id) => `signal-row-${id}`,
  filterDirection: "signals-filter-direction",
  filterStrategy: "signals-filter-strategy",
  filterGrade: "signals-filter-grade",
  detail: "signal-detail",
  detailBack: "signal-detail-back",
};

export const REJECTED = {
  table: "rejected-table",
  row: (id) => `rejected-row-${id}`,
};

export const LOGS = {
  console: "logs-console",
  filterLevel: "logs-filter-level",
  filterCategory: "logs-filter-category",
};

export const PAPER = {
  shell: "paper-shell",
  kpiBalance: "paper-kpi-balance",
  kpiEquity: "paper-kpi-equity",
  kpiRealized: "paper-kpi-realized",
  kpiUnrealized: "paper-kpi-unrealized",
  kpiWinRate: "paper-kpi-winrate",
  kpiFreeMargin: "paper-kpi-free-margin",
  kpiNetProfit: "paper-kpi-net-profit",
  kpiProfitFactor: "paper-kpi-pf",
  kpiAvgR: "paper-kpi-avg-r",
  kpiMaxDd: "paper-kpi-max-dd",
  equityChart: "paper-equity-chart",
  drawdownChart: "paper-drawdown-chart",
  dailyPnlChart: "paper-daily-pnl-chart",
  openTrades: "paper-open-trades",
  closedTrades: "paper-closed-trades",
  byStrategy: "paper-by-strategy",
  byRegime: "paper-by-regime",
  byPair: "paper-by-pair",
  byDirection: "paper-by-direction",
  byScore: "paper-by-score",
  resetBtn: "paper-reset-btn",
  backfillBtn: "paper-backfill-btn",
};

export const SELECTOR = {
  shell: "selector-shell",
  regimeDist: "selector-regime-dist",
  allowed: "selector-allowed",
  blocked: "selector-blocked",
  noTrade: "selector-no-trade",
  reasons: "selector-reasons",
};

export const SELECTOR_V2 = {
  shell: "selector-v2-shell",
  status: "selector-v2-status",
  allowed: "selector-v2-allowed",
  blocked: "selector-v2-blocked",
  agreement: "selector-v2-agreement",
  rImprovement: "selector-v2-r-improvement",
  allowReasons: "selector-v2-allow-reasons",
  blockReasons: "selector-v2-block-reasons",
};

export const AIREVIEW = {
  panel: "signal-ai-review",
  generateBtn: "signal-ai-review-btn",
};

export const SETTINGS = {
  paperEnabledToggle: "settings-paper-enabled",
  paperBalanceInput: "settings-paper-balance",
  paperRiskInput: "settings-paper-risk",
  paperLevMajorsInput: "settings-paper-lev-majors",
  paperLevDefaultInput: "settings-paper-lev-default",
  modeSelect: "settings-mode-select",
  intervalInput: "settings-interval-input",
  minScoreInput: "settings-min-score-input",
  maxPairsInput: "settings-max-pairs-input",
  riskInput: "settings-risk-input",
  weexKeyInput: "settings-weex-key",
  weexSecretInput: "settings-weex-secret",
  weexPassInput: "settings-weex-pass",
  tgTokenInput: "settings-tg-token",
  tgChatInput: "settings-tg-chat",
  fundingSoftInput: "settings-funding-soft",
  fundingHardInput: "settings-funding-hard",
  oiSoftInput: "settings-oi-soft",
  oiHardInput: "settings-oi-hard",
  trendingUpMinAdxInput: "settings-trending-up-min-adx",
  trendPullbackMinVolInput: "settings-trend-pullback-min-vol",
  enableLiquiditySweepToggle: "settings-enable-liquidity-sweep",
  saveBtn: "settings-save-btn",
  testTgBtn: "settings-test-telegram-btn",
  strategyCheckbox: (name) => `settings-strategy-${name}`,
};

export const BACKTEST = {
  pairSelect: "backtest-pair-select",
  strategySelect: "backtest-strategy-select",
  timeframeSelect: "backtest-timeframe-select",
  balanceInput: "backtest-balance-input",
  riskInput: "backtest-risk-input",
  barsInput: "backtest-bars-input",
  runBtn: "backtest-run-btn",
  result: "backtest-result",
  equityChart: "backtest-equity-chart",
  trades: "backtest-trades-table",
};
